export enum SELECT_OPTIONS_ENUM {
  'CODE' = '代码',
  'VIEW' = '预览'
}
